import { Group } from '../types/Group';

const isDefaultGroup = (group?: Group | null): boolean => !!group?.defaultGroup;

export { isDefaultGroup };
